import { authHeader } from '../../_helpers';
import axios from 'axios';

export const competencySevice = {
    competencyData,
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')


function competencyData(data) {
    return axios.post(`/analytics/analytics_organisation/team/analyse/competency/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/Analyze/competency.service.js